/* ChazaCo — banner de consentimiento de cookies.
   Usa la Customer Privacy API nativa de Shopify (no bloquea scripts a mano):
   https://shopify.dev/docs/api/customer-privacy
   Esto aplica las decisiones directamente a los pixels/audiences/checkout
   que Shopify ya gestiona (Google & YouTube, Meta, TikTok, etc.). */
(function () {
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function init() {
    var banner = document.getElementById('chzCookieBanner');
    if (!banner) return;

    var mainView = document.getElementById('chzCookieMain');
    var prefsView = document.getElementById('chzCookiePrefs');
    var acceptBtn = document.getElementById('chzCookieAccept');
    var rejectBtn = document.getElementById('chzCookieReject');
    var customizeBtn = document.getElementById('chzCookieCustomize');
    var backBtn = document.getElementById('chzCookieBack');
    var saveBtn = document.getElementById('chzCookieSavePrefs');
    var prefAnalytics = document.getElementById('chzCookiePrefAnalytics');
    var prefMarketing = document.getElementById('chzCookiePrefMarketing');
    var prefPreferences = document.getElementById('chzCookiePrefPreferences');

    var doNotSellLink = document.querySelector('.chz-do-not-sell-link');
    var doNotSellModal = document.getElementById('chzDoNotSellModal');
    var doNotSellOverlay = document.getElementById('chzDoNotSellOverlay');
    var doNotSellClose = document.getElementById('chzDoNotSellClose');
    var doNotSellConfirm = document.getElementById('chzDoNotSellConfirm');
    var doNotSellConfirmed = document.getElementById('chzDoNotSellConfirmed');

    function hideBanner() {
      banner.hidden = true;
    }

    function showMain() {
      if (mainView) mainView.hidden = false;
      if (prefsView) prefsView.hidden = true;
    }

    function showPrefs() {
      var api = window.Shopify && window.Shopify.customerPrivacy;
      if (api) {
        var current = api.currentVisitorConsent();
        if (prefAnalytics) prefAnalytics.checked = current.analytics !== 'no';
        if (prefMarketing) prefMarketing.checked = current.marketing !== 'no';
        if (prefPreferences) prefPreferences.checked = current.preferences !== 'no';
      }
      if (mainView) mainView.hidden = true;
      if (prefsView) prefsView.hidden = false;
    }

    function setConsent(consent) {
      var api = window.Shopify && window.Shopify.customerPrivacy;
      if (!api) return;
      api.setTrackingConsent(consent, hideBanner);
    }

    if (acceptBtn) {
      acceptBtn.addEventListener('click', function () {
        setConsent({ analytics: true, marketing: true, preferences: true });
      });
    }

    if (rejectBtn) {
      rejectBtn.addEventListener('click', function () {
        setConsent({ analytics: false, marketing: false, preferences: false });
      });
    }

    if (customizeBtn) customizeBtn.addEventListener('click', showPrefs);
    if (backBtn) backBtn.addEventListener('click', showMain);

    if (saveBtn) {
      saveBtn.addEventListener('click', function () {
        setConsent({
          analytics: !!(prefAnalytics && prefAnalytics.checked),
          marketing: !!(prefMarketing && prefMarketing.checked),
          preferences: !!(prefPreferences && prefPreferences.checked),
        });
      });
    }

    /* ── "No vender ni compartir mi informacion" (CCPA/VCDPA) ───
       Se maneja como un flujo aparte, iniciado por el visitante --
       nunca se aplica automaticamente al cargar la pagina. */
    function openDoNotSellModal(e) {
      if (e) e.preventDefault();
      if (!doNotSellModal) return;
      doNotSellModal.hidden = false;
    }

    function closeDoNotSellModal() {
      if (!doNotSellModal) return;
      doNotSellModal.hidden = true;
    }

    if (doNotSellLink) doNotSellLink.addEventListener('click', openDoNotSellModal);
    if (doNotSellClose) doNotSellClose.addEventListener('click', closeDoNotSellModal);
    if (doNotSellOverlay) doNotSellOverlay.addEventListener('click', closeDoNotSellModal);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && doNotSellModal && !doNotSellModal.hidden) closeDoNotSellModal();
    });

    if (doNotSellConfirm) {
      doNotSellConfirm.addEventListener('click', function () {
        var api = window.Shopify && window.Shopify.customerPrivacy;
        if (!api) return;
        api.setTrackingConsent({ sale_of_data: false }, function () {
          doNotSellConfirm.hidden = true;
          if (doNotSellConfirmed) doNotSellConfirmed.hidden = false;
        });
      });
    }

    /* ── Cargar la Customer Privacy API y decidir si mostrar el banner ── */
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) {
        if (error) return;
        var api = window.Shopify.customerPrivacy;

        if (api.shouldShowBanner()) {
          banner.hidden = false;
        }

        if (doNotSellLink && api.saleOfDataRegion()) {
          doNotSellLink.hidden = false;
        }
      }
    );
  }

  ready(init);
})();
